import { forwardRef } from "@kirvanobr/system";
import { useEffect } from "react";

import { useModalHeader, UseModalHeaderProps } from "./use-modal-header";

export interface ModalHeaderProps extends UseModalHeaderProps {}

const ModalHeader = forwardRef<"header", ModalHeaderProps>((props, ref) => {
  const {
    Component,
    icon,
    description,
    children,
    setHeaderMounted,
    getHeaderProps,
    getHeaderIconProps,
    getHeaderTitleProps,
    getHeaderDescriptionProps,
  } = useModalHeader(props);

  /**
   * Notify us if this component was rendered or used,
   * so we can append `aria-labelledby` automatically
   */
  useEffect(() => {
    setHeaderMounted(true);

    return () => setHeaderMounted(false);
  }, [setHeaderMounted]);

  return (
    <Component {...getHeaderProps()}>
      {icon && <span {...getHeaderIconProps()}>{icon}</span>}
      <div {...getHeaderTitleProps()}>
        {children}
        {description && <p {...getHeaderDescriptionProps()}>{description}</p>}
      </div>
    </Component>
  );
});

ModalHeader.displayName = "UI.ModalHeader";

export default ModalHeader;
